import { getInputBorderStyle, getInputValueColorStyle, useStyleParams } from '../../contexts/style-params-context';
import { TextFieldTheme } from 'wix-ui-tpa/cssVars';
import { InputBorderStyle } from '../../constants';
import { useConfig } from '../../contexts/config-context';
export function useTpaStyleParams() {
  const {
    isMobile
  } = useConfig();
  const styleParams = useStyleParams();
  const inputTheme = getTextInputTheme(styleParams, Boolean(isMobile));
  const isBorderStyleBottom = getIsBorderStyleBottom(styleParams, Boolean(isMobile));
  const isBorderStyleNone = getIsBorderStyleNone(styleParams, Boolean(isMobile));
  const inputValueColor = getInputValueColorStyle(styleParams, Boolean(isMobile));
  return {
    inputTheme,
    inputValueColor,
    isBorderStyleNone,
    isBorderStyleBottom
  };
}
function getTextInputTheme(styleParams, mobile) {
  const borderStyle = getInputBorderStyle(styleParams, mobile);
  return borderStyle === InputBorderStyle.Bottom ? TextFieldTheme.Line : TextFieldTheme.Box;
}
function getIsBorderStyleNone(styleParams, mobile) {
  const borderStyle = getInputBorderStyle(styleParams, mobile);
  return borderStyle === InputBorderStyle.None;
}
function getIsBorderStyleBottom(styleParams, mobile) {
  const borderStyle = getInputBorderStyle(styleParams, mobile);
  return borderStyle === InputBorderStyle.Bottom;
}
//# sourceMappingURL=use-tpa-style-params.js.map